import { useState, useCallback } from "react";

export default function useDashTheme() {
  const [dark, setDark] = useState(() => localStorage.getItem("dash-theme") === "dark");
  const toggle = useCallback(() => {
    setDark((d) => {
      const next = !d;
      localStorage.setItem("dash-theme", next ? "dark" : "light");
      return next;
    });
  }, []);
  return [dark, toggle];
}
